import React from 'react';
import { CustomerInfoDto } from 'src/api/v2';
import CompanyInformationAboutTab from './CompanyInformationAboutTab';
import CompanyInformationEconomyTab from './CompanyInformationEconomyTab';
import CompanyInformationRegistreTab from './CompanyInformationRegistreTab';
import { useTranslation } from 'react-i18next';
import { Tabs } from '@innovationnorway/cl-react';

type Props = {
  company: CustomerInfoDto;
};
const tabs = ['about', 'register', 'economy'] as const;

const CompanyInformationTabs = ({ company }: Props) => {
  const { t: tSiva } = useTranslation('siva');

  return (
    <Tabs defaultValue="about">
      <Tabs.List>
        {tabs.map((tab) => (
          <Tabs.Tab key={'tab__' + tab} value={tab}>
            {tSiva(`companyTabs.tabs.${tab}`)}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      <Tabs.Panel value="about">
        <CompanyInformationAboutTab company={company} />
      </Tabs.Panel>
      <Tabs.Panel value="register">
        <CompanyInformationRegistreTab company={company} />
      </Tabs.Panel>
      <Tabs.Panel value="economy">
        <CompanyInformationEconomyTab company={company} />
      </Tabs.Panel>
    </Tabs>
  );
};

export default CompanyInformationTabs;
